import { Label } from '@/components/ui/label';
import { Checkbox } from '@/components/ui/checkbox';
import { startTimeOptions, endTimeOptions, marginOptions } from './constants';

export function ProgrammeTimingSection({ form, index, roundNum, contentType, dances, updateGradeForm }) {
  const prefix = roundNum === 1 ? 'round_one' : 'round_two';
  const timingType = form[`${prefix}_timing_type`] || 'maximum';
  const addMargin = form[`${prefix}_add_margin`] || false;
  const isStyledance = contentType === 'Styledance';
  
  return (
    <div className="mb-4 p-4 border rounded-lg bg-green-50">
      <h4 className="font-medium mb-3 text-green-800">
        Programme Timing {roundNum === 2 ? '(Round 2)' : '(Round 1)'}
      </h4>
      
      {/* Timing Structure */}
      <div className="mb-4">
        <Label className="text-sm text-muted-foreground">How is the timing for this programme structured?</Label>
        <div className="flex gap-6 mt-2">
          <label className="flex items-center gap-2 cursor-pointer">
            <input 
              type="radio" 
              name={`timing-type-${index}-${roundNum}`}
              value="maximum"
              checked={timingType === 'maximum'}
              onChange={() => updateGradeForm(index, `${prefix}_timing_type`, 'maximum')}
            />
            <span className="text-sm">Maximum Time</span>
          </label>
          <label className="flex items-center gap-2 cursor-pointer">
            <input 
              type="radio" 
              name={`timing-type-${index}-${roundNum}`}
              value="range"
              checked={timingType === 'range'}
              onChange={() => updateGradeForm(index, `${prefix}_timing_type`, 'range')}
            />
            <span className="text-sm">Range of Time</span>
          </label>
          <label className="flex items-center gap-2 cursor-pointer">
            <Checkbox 
              checked={addMargin}
              onCheckedChange={(val) => updateGradeForm(index, `${prefix}_add_margin`, val)}
            />
            <span className="text-sm">Add time margin?</span>
          </label>
        </div>
      </div>
      
      {/* Time Values */}
      <div className={isStyledance ? 'mb-4' : ''}>
        <Label className="text-sm text-muted-foreground">What are the timings based on the structure chosen?</Label>
        <div className="flex items-center gap-3 mt-2 flex-wrap">
          {/* Min time (disabled for Maximum Time) */}
          <select
            className={`border rounded px-2 py-1.5 text-sm w-20 ${timingType === 'maximum' ? 'bg-gray-100 opacity-50' : ''}`}
            value={form[`${prefix}_time_min`] || ''}
            onChange={(e) => updateGradeForm(index, `${prefix}_time_min`, e.target.value)}
            disabled={timingType === 'maximum'}
          >
            <option value="">--:--</option>
            {startTimeOptions.map(t => (
              <option key={t} value={t}>{t}</option>
            ))}
          </select>
          
          <span className="text-sm text-muted-foreground">to</span>
          
          {/* Max time */}
          <select
            className="border rounded px-2 py-1.5 text-sm w-20"
            value={form[`${prefix}_time_max`] || ''}
            onChange={(e) => updateGradeForm(index, `${prefix}_time_max`, e.target.value)}
          >
            <option value="">--:--</option>
            {endTimeOptions.map(t => (
              <option key={t} value={t}>{t}</option>
            ))}
          </select>
          
          {/* Margin (disabled if Add margin not checked) */}
          <span className={`text-sm ${!addMargin ? 'opacity-50' : ''}`}>+/-</span>
          <select
            className={`border rounded px-2 py-1.5 text-sm w-16 ${!addMargin ? 'bg-gray-100 opacity-50' : ''}`}
            value={form[`${prefix}_margin`] || ''}
            onChange={(e) => updateGradeForm(index, `${prefix}_margin`, e.target.value)}
            disabled={!addMargin}
          >
            <option value="">--</option>
            {marginOptions.map(m => (
              <option key={m} value={m}>{m}</option>
            ))}
          </select>
        </div>
      </div>
      
      {/* Styledance Compulsory Dance - stacked label and dropdown */}
      {isStyledance && (
        <div>
          <Label className="text-sm text-muted-foreground">Compulsory Dance *</Label>
          <select 
            className="w-full border rounded-lg px-3 py-2 mt-1"
            value={form[`${prefix}_styledance_id`] || ''}
            onChange={(e) => updateGradeForm(index, `${prefix}_styledance_id`, e.target.value)}
            required
          >
            <option value="">Select Dance</option>
            {dances.map(d => (
              <option key={d.dance_id} value={d.dance_id}>{d.name} ({d.tempo})</option>
            ))}
          </select>
        </div>
      )}
    </div>
  );
}
